import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    marginLeft: theme.spacing(4.375),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
  },
  noteText: {
    fontSize: `14px !important`,
    fontWeight: 400,
    lineHeight: '20px',
    color: '#191C1D',
  },
  generalText: {
    fontSize: '14px !important',
    fontWeight: '400 !important',
    lineHeight: '20px !important',
    color: '#2E3132',
  },
  divider: {
    width: '100%',
  },
  headingText: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    lineHeight: '24px !important',
  },
  fieldWidth: {
    width: theme.spacing(28.5),
  },
  fieldRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2.25),
  },
  subSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  info: {
    marginLeft: theme.spacing(1),
    width: theme.spacing(2),
    height: theme.spacing(2),
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '16px',
    letterSpacing: '0.15px',
    color: theme.palette.labraIcon.main,
  },
  inLineInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  fullWidthContainer: {
    width: '100%',
  },
  radioWithRadio: {
    '& > div > div > div': {
      width: '100%',
    },
  },
  inputWidth: {
    width: '100%',
  },
  authorizationDurationContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    justifyContent: 'space-between',
    width: '100%',
  },
  authorizationDurationInputWidth: {
    width: '50%',
  },
}))
